import { useEffect } from 'react';
import { VAIR_PRO_STATS_API, VairProStatsResponse } from 'constants/payloads/vair/proStats';
import { useApiGateway } from 'hooks/useApi';
import { useViewer } from 'hooks/useViewer';

/**
 * Counts for the VAIR PRO card. Fetched from an API route rather than a client
 * GraphQL query because `eventsAggregate` is admin-only (the `user` role has no
 * `allow_aggregations`), so the browser can't run the aggregate itself.
 */
export const useVairProStats = () => {
  const { userId } = useViewer();
  const { get, data, isLoading, isCalled } = useApiGateway<never, VairProStatsResponse>(
    VAIR_PRO_STATS_API,
  );

  useEffect(() => {
    if (userId) get();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return {
    ratingSessions: data?.ratingSessions ?? 0,
    integratedEvents: data?.integratedEvents ?? 0,
    // `isLoading` is false while idle, so it alone would flash a 0 before the
    // request even fires. Only trust the counts once the request has settled.
    statsResolved: isCalled && !isLoading,
  };
};
